import { z } from "zod/v4";
import { defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { SiteIdCodec } from "@visioni/a3s-schema/codecs";
import { FEATURE_NAME } from "../constants";

export const UpdateSitePathParams = z.object({
  siteId: SiteIdCodec,
});

export const UpdateSiteBody = z.object({
  siteName: z.string().min(1),
});
export type UpdateSiteBody = z.input<typeof UpdateSiteBody>;

export const UpdateSiteResponse = z.object({
  siteId: SiteIdCodec,
  siteName: z.string(),
});
export type UpdateSiteResponse = z.output<typeof UpdateSiteResponse>;

export const siteResource = defineResource({
  feature: FEATURE_NAME,
  resource: "sites/{siteId}",
  resourcePathSchema: UpdateSitePathParams,
  scope: "tenant",
});

export const updateSiteEndpoint = defineEndpoint(siteResource, {
  method: "PUT",
  bodySchema: UpdateSiteBody,
  responseSchema: UpdateSiteResponse,
});
